import { Component, OnInit } from '@angular/core';
import 'hammerjs';
import { NguCarousel } from '@ngu/carousel';
import {TranslationsService} from '../services/translations.service';
import {AboutService} from '../services/about.service';
import {BuildingService} from '../services/building.service';
import {Config} from '../config';

@Component({
  selector: 'app-constuct-us',
  templateUrl: './constuct-us.component.html',
  styleUrls: ['./constuct-us.component.css']
})
export class ConstuctUsComponent implements OnInit {
  public carouselTile: NguCarousel;
  wos: any;
  lang: any;
  index: number;
  buildings: any;
  infos: any;
  user: any;
  public backendUrl: any = new Config();
  backgroundImages: any;
  constructor(private translationsService: TranslationsService,
              private aboutService: AboutService,
              private buildingService: BuildingService) {
    this.translationsService.langName$.subscribe((res) => {
      this.lang = res;
    });
  }
  socials: any;

  ngOnInit() {
    this.user = {
      fullName: '',
      email: '',
      message: ''
    }
    this.index = 0;
    this.lang = localStorage.getItem('lang');
    this.wos = {field13: {}, field7: {}, field26: {}, field28: {}, field27: {}, field29: {}, field20: {}, field21: {}, field22: {}, field23: {}, field24: {}, field25: {}};
    this.backgroundImages = [];
    this.translationsService.getTranslations().subscribe(resp => {
      if (!resp.error) {
        this.wos.field13 = resp.data[0].field13;
        this.wos.field7 = resp.data[0].field7;
        this.wos.field26 = resp.data[0].field26;
        this.wos.field28 = resp.data[0].field28;
        this.wos.field27 = resp.data[0].field27;
        this.wos.field29 = resp.data[0].field29;
        this.wos.field20 = resp.data[0].field20;
        this.wos.field21 = resp.data[0].field21;
        this.wos.field22 = resp.data[0].field22;
        this.wos.field23 = resp.data[0].field23;
        this.wos.field24 = resp.data[0].field24;
        this.wos.field25 = resp.data[0].field25;
        this.buildingService.getBuildings().subscribe(respo => {
          if (!respo.error) {
            this.buildings = respo.data;
            this.aboutService.getInfo().subscribe(response => {
              if (!response.error) {
                this.infos = response.data;
                for (let i = 0; i < this.infos.length; i++) {
                  this.infos[i].buildingId = this.buildings.filter( obj => {
                    return obj._id === this.infos[i].buildingId;
                  })[0];
                }
                this.aboutService.getSliderImages().subscribe( res => {
                  if (!res.error) {
                    this.backgroundImages = res.data;
                  }
                });
                this.aboutService.getSocial().subscribe( re => {
                  if (!re.error) {
                    this.socials = re.data;
                  }
                });
              }
            });
          }
        });
      }
    });
    this.carouselTile = {
      grid: {xs: 1, sm: 1, md: 1, lg: 1, all: 0},
      slide: 1,
      speed: 400,
      interval: 4000,
      point: {
        visible: true
      },
      load: 2,
      touch: true,
      loop: true,
      custom: 'banner'
    };
  }

  sendMessage() {
    this.aboutService.sendMessage(this.user).subscribe(res => {
      if (!res.error) {
        this.user = {
          fullName: '',
          email: '',
          message: ''
        };
      }else {
        this.user = {
          fullName: '',
          email: '',
          message: ''
        };
      }
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/HP Spectre/Desktop/Regineh Hotel/reginehUser/src/app/constuct-us/constuct-us.component.ts